// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Cluster } from './Cluster';
import {
  ClusterFromJSON,
  ClusterFromJSONTyped,
  ClusterToJSON,
  ClusterToJSONTyped,
} from './Cluster';

/**
 *
 * @export
 * @interface ClusterListResponse
 */
export interface ClusterListResponse {
  /**
   *
   * @type {Array<Cluster>}
   * @memberof ClusterListResponse
   */
  items?: Array<Cluster>;
}

/**
 * Check if a given object implements the ClusterListResponse interface.
 */
export function instanceOfClusterListResponse(
  value: object,
): value is ClusterListResponse {
  return true;
}

export function ClusterListResponseFromJSON(json: any): ClusterListResponse {
  return ClusterListResponseFromJSONTyped(json, false);
}

export function ClusterListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterListResponse {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(ClusterFromJSON),
  };
}

export function ClusterListResponseToJSON(json: any): ClusterListResponse {
  return ClusterListResponseToJSONTyped(json, false);
}

export function ClusterListResponseToJSONTyped(
  value?: ClusterListResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(ClusterToJSON),
  };
}
